module.exports = function() {
  return new Worker(__webpack_public_path__ + "f768e921e932e6cbdc57.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-pdf/node_modules/worker-loader/dist/cjs.js!./node_modules/react-pdf/node_modules/pdfjs-dist/build/pdf.worker.js
// module id = 1791
// module chunks = 2